import { render, staticRenderFns } from "./TabelPenerimaManfaat.vue?vue&type=template&id=68b5abe2&scoped=true"
import script from "./TabelPenerimaManfaat.vue?vue&type=script&lang=js"
export * from "./TabelPenerimaManfaat.vue?vue&type=script&lang=js"
import style0 from "./TabelPenerimaManfaat.vue?vue&type=style&index=0&id=68b5abe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b5abe2",
  null
  
)

export default component.exports